/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import axiosMain from "../../../http/axios/axios_main";
import CustomToast from "../../../components/Toast";
import {
  bindAuctionDateRequest,
  bindAuctioneerRequest,
  bindSaleNoRequest,
  fetchAuctionRequest,
  getExportData,
  getExportDataApiCall,
} from "../../../store/actions";
import { useSelector } from "react-redux";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useAuctionDetail } from "../../../components/common/AunctioneerDeteailProvider";
import Base64ToExcelDownload from "../../Base64ToExcelDownload";
import { uploadedFileDownload } from "../../uploadDocument/UploadedFileDownload";
import { NO_OF_RECORDS } from "../../../constants/commonConstants";
import { ThreeDots } from "react-loader-spinner";

function DeliveryInstructionAdviceWarehouse({ modalRight }) {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 0; i <= 5; i++) {
    const year = currentYear - i;
    years.push(year);
  }
  const { auctionDetailId, auctionCenterUserId, auctionCenterId, userId } =
    useAuctionDetail();
  const [expanded, setExpanded] = React.useState("panel1");
  const handleChangeFactoryOwnerExpand = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    if ("panel2" == panel && isExpanded) {
      setViewBuyerData([]);
    }
  };
  const [remarkValue, setRemarkValue] = useState("");
  const [ViewDealBookTaoData, setViewDealBookTaoData] = useState([]);
  const [allSaleNoList, setallSaleNoList] = useState([]);
  const [allAuctionCenterList, setallAuctionCenterList] = useState([]);
  const [season, setSeason] = useState(currentYear);
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedDataOfList, setselectedDataOfList] = useState([]);
  const pinDefaultValues = [];
  const [pinValues, setPinValues] = useState(pinDefaultValues);
  const [selectedDataOfExportExcel, setselectedDataOfExportExcel] = useState(
    []
  );
  const [pageNo, setPageNo] = useState(2);
  const [loader, setLoader] = useState(false);
  const [ViewBuyerData, setViewBuyerData] = useState([]);
  const [DealBookSearch, setDealBookSearch] = useState({
    saleNo: null,
    loggedinfromAuctionCenterName: auctionCenterId,
    status: null,
    buyerNameForWarehouse: null,
    saleYear: String(currentYear),
    deliveryOrderNo: null,
    warehouseId: userId
  });
  const StatusList = [
    { status: "All", id: null },
    { status: "Split DI", id: 0 },
    { status: "DI Generated", id: 1 },
    { status: "DI Signed", id: 2 },
    { status: "Delivery Requested", id: 3 },
    { status: "Delivery Completed", id: 4 },
  ];
  const [isDisabled, setIsDisabled] = useState(false);
  const getAllAuctionCenterList = useSelector(
    (res) => res.warehouseUserRegistration.auctionCenter?.responseData
  );
  const auctineerList = useSelector(
    (state) => state.saleNoReducer.auctineerList
  );
  const saleNoData = useSelector((state) => state.saleNoReducer.saleList);
  const ExportExcelDatas = useSelector(
    (state) => state.documentReducer.exportData.responseData?.exported_file
  );
  const getExportDataApiCallResponse = useSelector(
    (state) => state.documentReducer.exportDataApiCall
  );
  const [exportType, setexportType] = useState("");

  const handleExport = (exportType) => {
    const updatedDealBookSearch = {
      ...DealBookSearch,
      url: "/postauction/deliveryinstruction/warehouse/search",
      exportType: exportType,
      isExport: 1,
    };
    setexportType(exportType);
    dispatch(getExportData(updatedDealBookSearch));
  };
  const Validate = () => {
    let isValid = true;
    if (
      DealBookSearch.saleYear == null ||
      DealBookSearch.saleYear == "SELECT" ||
      DealBookSearch.saleYear == ""
    ) {
      CustomToast.error("Please select all values");
      isValid = false;
      return;
    }
    if (
      DealBookSearch.saleNo == null ||
      DealBookSearch.saleNo == "SELECT" ||
      DealBookSearch.saleNo == ""
    ) {
      CustomToast.error("Please select all value");
      isValid = false;
      return;
    }

    // if (
    //   DealBookSearch.buyerName == null ||
    //   DealBookSearch.buyerName == "SELECT" ||
    //   DealBookSearch.buyerName == ""
    // ) {
    //   CustomToast.error("Please select all value");
    //   isValid = false;
    //   return;
    // }
    if (
      DealBookSearch.loggedinfromAuctionCenterName == null ||
      DealBookSearch.loggedinfromAuctionCenterName == "SELECT" ||
      DealBookSearch.loggedinfromAuctionCenterName == ""
    ) {
      CustomToast.error("Please select all value");
      isValid = false;
      return;
    }
    // if (
    //   DealBookSearch.deliveryOrderNo == null ||
    //   DealBookSearch.deliveryOrderNo == "SELECT" ||
    //   DealBookSearch.deliveryOrderNo == ""
    // ) {
    //   CustomToast.error("Please select all value");
    //   isValid = false;
    //   return;
    // }
    return isValid;
  };
  const ViewDealBookList = async (message) => {
    try {
      const response = await axiosMain.post(
        "/postauction/deliveryinstruction/warehouse/search",
        { ...DealBookSearch, pageNo: 1, noOfRecords: NO_OF_RECORDS }
      );
      if (response.data.statusCode == 200) {
        setViewDealBookTaoData(response.data.responseData);
        if (response.data.responseData.length < 20) {
          setIsDisabled(true);
        }
        else {
          setIsDisabled(false);
        }
      } else {
        if (message == "Hide") {

        } else {
          CustomToast.error(response.data.message)
        }

      }

    } catch (error) {
      console.error("Error:", error);
    }
  };
  const SearchViewDealBook = async (e) => {
    e.preventDefault();
    if (Validate()) {
      setPinValues('')
      setViewDealBookTaoData([]);
      setLoader(true);
      const delay = new Promise((resolve) => setTimeout(resolve, 500));
      await delay;
      try {
        await ViewDealBookList("show");
      } finally {
        setLoader(false);
      }
    }
  };
  const handleViewMore = async () => {
    setIsDisabled(true);
    try {
      const response = await axiosMain.post(
        "/postauction/deliveryinstruction/warehouse/search",
        {
          ...DealBookSearch,
          pageNo: pageNo,
          noOfRecords: NO_OF_RECORDS, // Pass NO_OF_RECORDS as 20
        }
      );

      if (Array.isArray(response.data.responseData)) {
        if (response.data.responseData.length === 0) {
          setIsDisabled(true);
          // Handle case when response is empty if necessary
        } else {
          setViewDealBookTaoData((prevData) => [
            ...prevData,
            ...response.data.responseData,
          ]);
          setPageNo((prevPageNo) => prevPageNo + 1); // Increment pageNo

          if (response.data.responseData.length < 20) {
            setIsDisabled(true);
          }
          else {
            setIsDisabled(false);
          }
        }
      } else {
        console.error(
          "Response data is not an array:",
          response.data.responseData
        );
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleViewDealSearch = (e) => {
    const { name, value } = e.target;
    const selectedValue = value != "" ? value : null;
    setDealBookSearch((prevState) => {
      const updatedState = { ...prevState, [name]: selectedValue };
      if (value === "All") {
        updatedState.status = null;
      }

      return updatedState;
    });

    setSeason(DealBookSearch.season);
  };
  const getStatusText = (id) => {
    switch (id) {
      case 0:
        return "Split DI";
      case 1:
        return "DI Generated";
      case 2:
        return "DI Signed";
      case 3:
        return "Delivery Requested";
      case 4:
        return "Delivery Completed";
      default:
        return "-";
    }
  };
  const listCheckboxChange = (index, isChecked) => {
    if (isChecked) {
      // If the row is checked, add the selected data to the array
      const selectedRow = {
        deliveryInstructionId: ViewDealBookTaoData[index].deliveryInstructionId,
        status: ViewDealBookTaoData[index].status,
      };

      const selectedRowForExportExcel = {
        sr: index,
        deliveryInstructionId: ViewDealBookTaoData[index].deliveryInstructionId,
        totalPackage: ViewDealBookTaoData[index].totalPackage,
        lotNo: ViewDealBookTaoData[index].lotNo,
        markName: ViewDealBookTaoData[index].markName,
        auctioneerName: ViewDealBookTaoData[index].auctioneerName,
        wareHouseName: ViewDealBookTaoData[index].wareHouseName,
        referenceNo: ViewDealBookTaoData[index].referenceNo,
        deliveryInstructionAdviceNo:
          ViewDealBookTaoData[index].deliveryInstructionAdviceNo,
        dealIdentificationNo: ViewDealBookTaoData[index].dealIdentificationNo,
        diDate: ViewDealBookTaoData[index].diDate,
        totalQuantity: ViewDealBookTaoData[index].totalQuantity,
        totalAmount: ViewDealBookTaoData[index].totalAmount,
        status: ViewDealBookTaoData[index].status,
      };

      setselectedDataOfList((prevSelectedData) => [
        ...prevSelectedData,
        selectedRow,
      ]);

      setselectedDataOfExportExcel((prevSelectedData) => [
        ...prevSelectedData,
        selectedRowForExportExcel,
      ]);
    } else {
      // If the row is unchecked, remove the selected data from the array
      setselectedDataOfList((prevSelectedData) =>
        prevSelectedData.filter(
          (row) =>
            row.deliveryInstructionId !==
            ViewDealBookTaoData[index].deliveryInstructionId
        )
      );
      setselectedDataOfExportExcel((prevSelectedData) =>
        prevSelectedData.filter(
          (row) =>
            row.deliveryInstructionId !==
            ViewDealBookTaoData[index].deliveryInstructionId
        )
      );
    }

    // Update the selectedRows state
    if (isChecked) {
      setSelectedRows([...selectedRows, index]);
    } else {
      setSelectedRows(selectedRows.filter((rowIndex) => rowIndex !== index));
    }
  };
  const ViewMore = (id, isExport, exportType) => {
    // Create an array of deliveryInstructionId from selectedDataOfList
    const deliveryIds = selectedDataOfList.map(
      (item) => item.deliveryInstructionId
    );

    // If id is provided and not null, use it as a single-item array
    const DataIds = id != null ? [id] : deliveryIds;

    // If no IDs are present, show an error toast
    if (DataIds.length === 0) {
      CustomToast.error("Please select at least one row before export.");
      return;
    }

    // Construct the payload with deliveryInstructionId as an array
    const payload = {
      deliveryInstructionId: DataIds,
      isExport: isExport,
      exportType: exportType,
    };

    // Define the URL for the POST request
    const url = `/postauction/deliveryinstruction/auctioneer/view`;

    // Perform the POST request using axios
    axiosMain
      .post(url, payload)
      .then((response) => {
        if (response.data.statusCode === 200) {
          CustomToast.success(response.data.message);
          setViewBuyerData(response.data.responseData);
          setExpanded("panel2");
        } else {
          CustomToast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.error("POST request failed");
        console.error("Error:", error);
      });
  };
  const completedDelivery = (index, id, pin, remark) => {
    const Data = {
      deliveryInstructionId: id,
      pin: pin[index],
      remarks: remark,
    };

    if (!Data.remarks) {
      CustomToast.error("Please enter remarks");
      return;
    }
    // Validate remark length
    if (Data.remarks.length < 2) {
      CustomToast.error("Please enter minimum 2 characters");
      return;
    }
    if (Data.remarks.length > 500) {
      CustomToast.error("Allowed maximum 500 characters");
      return;
    }

    // Validate special characters in remark
    // Example: Allow only alphanumeric characters and spaces
    // const specialCharPattern = /[^a-zA-Z0-9\s]/;
    // if (specialCharPattern.test(Data.remarks)) {
    //   CustomToast.error(
    //     "Please enter alphanumeric value without special characters"
    //   );
    //   return;
    // }
    if (!Data.pin) {
      CustomToast.error("Please enter Pin");
      return;
    }

    axiosMain
      .post(
        `/postauction/deliveryinstruction/warehouse/completedDelivery`,
        Data
      )
      .then((response) => {
        if (response.data.statusCode === 200) {
          CustomToast.success(response.data.message);
          setViewDealBookTaoData([]);
          // setSelectedRows([]);
          // setselectedDataOfList([]);
          setRemarkValue("");
          setPinValues("");
          ViewDealBookList("Hide");
        } else {
          CustomToast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const reset = () => {
    setDealBookSearch({
      saleNo: String(currentYear),
      loggedinfromAuctionCenterName: auctionCenterId,
      status: "",
      buyerNameForWarehouse: "",
      saleYear: "",
      deliveryOrderNo: "",
      warehouseId: userId
    });

    setTimeout(() => {
      setDealBookSearch({
        saleNo: String(currentYear),
        loggedinfromAuctionCenterName: auctionCenterId,
        status: null,
        buyerNameForWarehouse: null,
        saleYear: null,
        deliveryOrderNo: null,
        warehouseId: userId
      });
    }, 0);
  };

  ViewDealBookTaoData?.forEach((item, index) => {
    pinDefaultValues[index] = item.pinDefaultValue;
  });

  useEffect(() => {
    if (ExportExcelDatas != null && true == getExportDataApiCallResponse) {
      dispatch(getExportDataApiCall(false));
      if ("excel" == exportType) {
        Base64ToExcelDownload(ExportExcelDatas, "View_DealBook.xlsx");
      } else {
        uploadedFileDownload(
          ExportExcelDatas,
          "View_DealBook.pdf",
          `data:application/pdf;base64`
        );
      }
    }
  });
  useEffect(() => {
    if (DealBookSearch.saleYear !== "") {
      dispatch(
        bindSaleNoRequest({
          season: DealBookSearch.saleYear,
          auctionCenterId: auctionCenterId,
        })
      );
    }
  }, [DealBookSearch.saleYear]);
  useEffect(() => {
    if (DealBookSearch.saleNo !== null) {
      dispatch(
        bindAuctionDateRequest({
          saleYear: DealBookSearch.season,
          saleNo: DealBookSearch.saleNo,
          auctionCenterId: auctionCenterId,
        })
      );
    }
  }, [DealBookSearch.saleNo]);
  useEffect(() => {
    dispatch(fetchAuctionRequest());
    dispatch(bindAuctioneerRequest({ roleCode: "AUCTIONEER" }));
    dispatch(fetchAuctionRequest());
  }, []);
  useEffect(() => {
    setallAuctionCenterList(getAllAuctionCenterList);
    setallSaleNoList(saleNoData);
  }, [getAllAuctionCenterList, auctineerList, saleNoData]);

  useEffect(() => {
    setViewDealBookTaoData([]);
  }, [DealBookSearch.saleNo, DealBookSearch.status])

  return (
    <div>
      <div>
        <Accordion
          expanded={expanded === "panel1"}
          className={`${expanded === "panel1" ? "active" : ""}`}
          onChange={handleChangeFactoryOwnerExpand("panel1")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>List Delivery Instruction </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              {modalRight?.some((ele) => ele === "12") && (
                <form onSubmit={SearchViewDealBook}>
                  <div className="row">
                    <div className="col-xl-2">
                      <div className="FomrGroup">
                        <label>Sale Year</label>
                        <label class="errorLabel"> * </label>
                        <select
                          name="saleYear"
                          value={DealBookSearch.saleYear}
                          className="form-control select-form"
                          onChange={handleViewDealSearch}
                        >
                          <option value="">Select Sale Year</option>
                          {years.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-2">
                      <div className="FomrGroup">
                        <label>Sale No</label>
                        <label class="errorLabel"> * </label>
                        <select
                          name="saleNo"
                          onChange={handleViewDealSearch}
                          value={DealBookSearch.saleNo}
                          className="form-control select-form"
                        >
                          <option value="">Select Sale No</option>
                          {allSaleNoList.map((saleNoItem, index) => (
                            <option
                              value={parseInt(saleNoItem.saleNo)}
                              key={index}
                            >
                              {saleNoItem.saleNo}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-2">
                      <div className="FomrGroup">
                        <label>Delivery Status</label>
                        <label className="errorLabel"> * </label>
                        <select
                          name="status"
                          value={DealBookSearch.status || null}
                          className="form-control select-form"
                          onChange={handleViewDealSearch}
                        >
                          {StatusList.map((statusItem) => (
                            <option
                              key={statusItem.status}
                              value={statusItem.id}
                            >
                              {statusItem.status}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-2">
                      <div className="FomrGroup">
                        <label>Buyer Name </label>
                        {/* <label class="errorLabel"> * </label> */}
                        <input
                          type="text"
                          name="buyerNameForWarehouse"
                          value={DealBookSearch.buyerNameForWarehouse}
                          className="form-control select-form"
                          onChange={handleViewDealSearch}
                        />
                      </div>
                    </div>
                    <div className="col-xl-2">
                      <div className="FomrGroup">
                        <label>Buyer From </label>
                        <label class="errorLabel"> * </label>
                        <select
                          name="loggedinfromAuctionCenterName"
                          value={DealBookSearch.loggedinfromAuctionCenterName}
                          className="form-control select-form"
                          onChange={handleViewDealSearch}
                        >
                          <option value="">Select Buyer From</option>
                          {allAuctionCenterList?.map(
                            (allAuctionCenterList, index) => (
                              <option
                                value={allAuctionCenterList.auctionCenterId}
                              >
                                {allAuctionCenterList.auctionCenterName}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="col-xl-2">
                      <div className="FomrGroup">
                        <label>Delivery Order No</label>
                        {/* <label class="errorLabel"> * </label> */}
                        <input
                          type="text"
                          name="deliveryOrderNo"
                          value={DealBookSearch.deliveryOrderNo}
                          className="form-control select-form"
                          onChange={handleViewDealSearch}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="BtnGroup">
                        <button type="submit" className="SubmitBtn">
                          Search
                        </button>
                        <button
                          type="button"
                          onClick={() => reset()}
                          className="SubmitBtn"
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12">
                      <div className="TableBox11">
                        <table className="table11" ref={tableRef}>
                          <thead>
                            <tr>
                              <th>Select Check Box</th>
                              <th>Sr.</th>
                              <th>Auction Center</th>
                              <th>Sale Year</th>
                              <th>Sale No</th>
                              <th>Seller Prompt Date</th>
                              <th>Buyer Prompt</th>
                              <th>Delivery Order No</th>
                              <th>Delivery Order Date</th>
                              <th>Auctioneer</th>
                              <th>Buyer</th>
                              <th>Seller</th>
                              <th>Delivery Identification Number</th>
                              <th>Lot No</th>
                              <th>Invoice No</th>
                              <th>Mark</th>
                              <th>Grade</th>
                              <th>Total No Packages</th>
                              <th>Net Weight in Kgs</th>
                              <th>Package Size</th>
                              <th>Package Type</th>
                              <th>Delivery Completed Date</th>
                              <th>Remarks</th>
                              <th>PIN</th>
                              <th>Status</th>
                              <th>Auction</th>
                              <th>Complete Button</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ViewDealBookTaoData?.length > 0 ? (
                              <>
                                {ViewDealBookTaoData?.map((item, index) => (
                                  <tr key={index}>
                                    <td>
                                      <input
                                        type="checkbox"
                                        name={`selected-${index}`}
                                        onChange={(e) =>
                                          listCheckboxChange(
                                            index,
                                            e.target.checked
                                          )
                                        }
                                      />
                                    </td>
                                    <td>{index + 1}</td>
                                    <td>
                                      {item.loggedinfromAuctionCenterName}
                                    </td>
                                    <td>{item.saleYear}</td>
                                    <td>{item.saleNo}</td>
                                    <td>{item.sellerPromptDate}</td>
                                    <td>{item.buyerPrompt}</td>
                                    <td>{item.deliveryOrderNo}</td>
                                    <td>{item.deliveryOrderDate}</td>
                                    <td>{item.auctioneerName}</td>
                                    <td>{item.buyerName}</td>
                                    <td>{item.sellerName}</td>
                                    <td>{item.deliveryInstructionAdviceNo}</td>
                                    <td>{item.lotNo}</td>
                                    <td>{item.invoiceNo}</td>
                                    <td>{item.markName}</td>
                                    <td>{item.gradeName}</td>
                                    <td>{item.totalPackages}</td>
                                    <td>{item.netweightinKgs}</td>
                                    <td>{item.packageSize}</td>
                                    <td>{item.packageType}</td>
                                    <td>
                                      {item.deliveryCompletedDate
                                        ? item.deliveryCompletedDate
                                        : "-"}
                                    </td>
                                    <td>
                                      {item.status == 4 ? (
                                        <>
                                          <input
                                            type="text"
                                            style={{ width: 100 }}
                                            name="remark"
                                            value={item.remarks}
                                            className="form-control  InputRemarkAndPin"
                                          />
                                        </>
                                      ) : (
                                        <>
                                          <input
                                            type="text"
                                            style={{ width: 100 }}
                                            name="remark"
                                            className="form-control InputRemarkAndPin"
                                            onChange={(e) =>
                                              setRemarkValue(e.target.value)
                                            }
                                          />
                                        </>
                                      )}
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        value={
                                          item.status == 3
                                            ? pinValues[index]
                                            : item.pin
                                        }
                                        style={{ width: 100 }}
                                        disabled={item.status != 3}
                                        name="pin"
                                        className="form-control InputRemarkAndPin"
                                        onChange={(e) => {
                                          const value = e.target.value;

                                          // Check if the input is numeric and its length is within the allowed limit
                                          if (/^\d*$/.test(value)) {
                                            if (value.length > 6) {
                                              CustomToast.error(
                                                "Allowed max 6 digit value"
                                              );
                                              return; // Don't update the state if length exceeds 6
                                            }

                                            const newPinValues = [...pinValues];
                                            newPinValues[index] = value;
                                            setPinValues(newPinValues);
                                          } else {
                                            CustomToast.error(
                                              "Invalid input: Only numeric values are allowed."
                                            );
                                          }
                                        }}
                                      />
                                    </td>
                                    <td>
                                      {getStatusText(parseInt(item.status))}
                                    </td>
                                    <td>
                                      {" "}
                                      <i
                                        className="fa fa-eye"
                                        onClick={() =>
                                          ViewMore(
                                            item.deliveryInstructionId,
                                            0,
                                            "string"
                                          )
                                        }
                                      ></i>
                                    </td>
                                    <td className="Actions">
                                      <div className="BtnGroup">
                                        <button
                                          type="button"
                                          className="w-auto"
                                          disabled={item.status != 3}
                                          onClick={() =>
                                            completedDelivery(
                                              index,
                                              item.deliveryInstructionId,
                                              pinValues,
                                              remarkValue
                                            )
                                          }
                                        >
                                          Completed Delivery
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </>
                            ) : (
                              <>
                                <tr>
                                  <td colSpan={27} className="text-center">
                                    {loader ? (
                                      <>
                                        <div className="">
                                          <ThreeDots
                                            visible={true}
                                            height="80"
                                            width="80"
                                            color="#4fa94d"
                                            radius="9"
                                            ariaLabel="three-dots-loading"
                                            wrapperStyle={{}}
                                            wrapperClass=""
                                          />
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <div className="NoData">
                                          No record found
                                        </div>
                                      </>
                                    )}
                                  </td>
                                </tr>
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="BtnGroup">
                        {modalRight?.some((ele) => ele === "48") && (
                          <button
                            className="SubmitBtn"
                            type="button"
                            // onClick={() => exportSelectedRowsToExcel()}
                            onClick={() => handleExport("excel")}
                          >
                            Export Excel
                          </button>
                        )}
                        {modalRight?.some((ele) => ele === "47") && (
                          <button
                            className="SubmitBtn"
                            type="button"
                            // onClick={() => DownloadPDF()}
                            onClick={() => handleExport("pdf")}
                          >
                            Export PDF
                          </button>
                        )}

                        <button
                          className="SubmitBtn"
                          type="button"
                          onClick={() => ViewMore(null)}
                        >
                          View Details
                        </button>

                        <button
                          class="SubmitBtn"
                          type="button"
                          onClick={handleViewMore}
                        >
                          View More
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              )}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel2"}
          className={`${expanded === "panel2" ? "active" : ""}`}
          onChange={handleChangeFactoryOwnerExpand("panel2")}
          TransitionProps={{ unmountOnExit: true }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>View Delivery Instruction</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div className="row mt-3">
                <div className="col-12">
                  <div className="TableBox">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Sr No.</th>
                          <th>Season</th>
                          <th>Sale No</th>
                          <th>Tea Type</th>
                          <th>DI No.</th>
                          <th>Warehouse</th>
                          <th>Reference No</th>
                          <th>Buyer</th>
                          <th>DI Date</th>
                          <th>Lot No</th>
                          <th>Garden Invoice No.</th>
                          <th>Mark</th>
                          <th>Grade</th>
                          <th>No of Packages</th>
                          <th>Lot Total Qty(Kgs)</th>
                          <th>Lot Sample Qty (Kgs)</th>
                          <th>Lot Qty Purchased (Kgs)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ViewBuyerData?.length > 0 ? (
                          <>
                            {ViewBuyerData?.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.season}</td>
                                <td>{item.saleNo}</td>
                                <td>{item.teaType}</td>
                                <td>{item.deliveryOrderNo}</td>
                                <td>{item.wareHouseName}</td>
                                <td>{item.referenceNo}</td>
                                <td>{item.buyerName}</td>
                                <td>{item.diDate == null ? '-' : item.diDate}</td>
                                <td>{item.lotNo}</td>
                                <td>{item.gardenInvoiceNo}</td>
                                <td>{item.markName}</td>
                                <td>{item.gradeName}</td>
                                <td>{item.noOfPackages}</td>
                                <td>{item.lotTotalQty}</td>
                                <td>{item.sampleQty}</td>
                                <td>{item.qtyPurchased}</td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <>
                            <tr>
                              <td colSpan={17} className="text-center">
                                {loader ? (
                                  <>
                                    <div className="">
                                      <ThreeDots
                                        visible={true}
                                        height="80"
                                        width="80"
                                        color="#4fa94d"
                                        radius="9"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="NoData">
                                      No record found
                                    </div>
                                  </>
                                )}
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}

export default DeliveryInstructionAdviceWarehouse;
